import { ENV_VARIABLES } from '@/constants';

import {
  DEVELOPMENT_ENVIRONMENT,
  PANORAMA_APP_NAME,
  PANORAMA_DEV_NAME_SUFFIX,
  PANORAMA_UAT_NAME_SUFFIX,
  STAGING_ENVIRONMENT,
  UAT_ENVIRONMENT
} from '../constants';
import type { PanoramaProductName } from '../types';

const DEV_PRODUCT_NAME: PanoramaProductName = {
  name: `${PANORAMA_APP_NAME} ${PANORAMA_DEV_NAME_SUFFIX}`,
  variant: 'dev'
};

const UAT_PRODUCT_NAME: PanoramaProductName = {
  name: `${PANORAMA_APP_NAME} ${PANORAMA_UAT_NAME_SUFFIX}`,
  variant: 'uat'
};

const DEFAULT_PRODUCT_NAME: PanoramaProductName = {
  name: PANORAMA_APP_NAME,
  variant: 'default'
};

const productNameByEnvironment: Record<string, PanoramaProductName> = {
  [DEVELOPMENT_ENVIRONMENT]: DEV_PRODUCT_NAME,
  [STAGING_ENVIRONMENT]: DEV_PRODUCT_NAME,
  [UAT_ENVIRONMENT]: UAT_PRODUCT_NAME
};

/**
 * Product name shown beside the Cropwise logo. Production and any unmapped
 * mode stay the regular navy wordmark. Dev is green; UAT is bold navy.
 */
const getPanoramaProductName = (
  environment: string | undefined = ENV_VARIABLES.ENVIRONMENT
): PanoramaProductName => {
  if (!environment) return DEFAULT_PRODUCT_NAME;

  return productNameByEnvironment[environment] ?? DEFAULT_PRODUCT_NAME;
};

export default getPanoramaProductName;
